import inRange from 'lodash/inRange';
import { messageTypes } from '../components/Messages';

export default (message, minVal, maxVal) => (value) => {
    let result;
    if (value && !inRange(parseInt(value, 10), minVal, maxVal + 1)) {
        result = { title: message, type: messageTypes.error };
    }
    return result;
};
